import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { WSClientProvider } from '@crm/websocket-client'
import { queryClient } from './lib/query-client'
import { wsClient } from './lib/ws-client'
import { routeTree } from './route-tree'
import './styles/globals.css'

const router = createRouter({ routeTree })

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Root element not found')

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <WSClientProvider client={wsClient}>
        <RouterProvider router={router} />
      </WSClientProvider>
    </QueryClientProvider>
  </StrictMode>,
)
